import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const corporateIndustries = [
  { key: 'hotel', href: '/corporate/hotel' },
  { key: 'residence', href: '/corporate/residence' },
  { key: 'finance', href: '/corporate/finance' },
  { key: 'luxury', href: '/corporate/luxury-sales' },
  { key: 'auto', href: '/corporate/automotive' },
  { key: 'chauffeur', href: '/corporate/chauffeur' },
];

export default function CorporateSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            CORPORATE TRAINING
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('home.corporate.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('home.corporate.subtitle')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-2xl mx-auto leading-relaxed">{__s}</p>))}
          {String(t('home.corporate.formatIntro')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.03em] max-w-2xl mx-auto leading-relaxed mt-4">{__s}</p>))}
        </div>

        {/* Training Scene Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14 max-w-[960px] mx-auto">
          <div className="relative h-64 md:h-80 overflow-hidden">
            <img
              src="/images/generated/corp-home-training-01.jpg"
              alt={t('home.corporate.img1Alt')}
              title={t('home.corporate.img1Title')}
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="relative h-64 md:h-80 overflow-hidden">
            <img
              src="/images/generated/corp-home-training-02.jpg"
              alt={t('home.corporate.img2Alt')}
              title={t('home.corporate.img2Title')}
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        {/* Industry Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-[960px] mx-auto mb-8">
          {corporateIndustries.map((industry) => (
            <Link
              key={industry.href}
              to={industry.href}
              className="group flex items-center gap-4 p-4 bg-background-50 border border-background-200/60 hover:border-accent-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.04em] mb-1 group-hover:text-accent-600 transition-colors">
                  {t(`home.corporate.${industry.key}.name`)}
                </h3>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed truncate">
                  {t(`home.corporate.${industry.key}.desc`)}
                </p>
              </div>
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-line text-accent-500 text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Additional Industries Note */}
        <p className="text-center text-[14px] text-foreground-500 tracking-[0.04em] mb-8">
          {t('home.corporate.more')}
          <br className="sm:hidden" />
          <Link to="/corporate" className="text-accent-600 hover:text-accent-500 transition-colors ml-1">
            {t('home.corporate.allIndustries')}
          </Link>
        </p>

        {/* Price & CTA */}
        <div className="text-center">
          <p className="text-[15px] text-foreground-600 tracking-[0.04em] mb-2">
            {t('home.corporate.halfDay')}<span className="text-foreground-900 font-medium">{t('home.corporate.halfDayPrice')}</span>{t('home.corporate.fullDay')}<span className="text-foreground-900 font-medium">{t('home.corporate.fullDayPrice')}</span>{t('home.corporate.fullDayEnd')}
          </p>
          {String(t('home.corporate.travel')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] mb-8">{__s}</p>))}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/corporate"
              className="btn-glow inline-block px-10 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('home.corporate.cta')}
            </Link>
            <Link
              to="/corporate/brochure"
              className="inline-block px-10 py-3.5 border border-accent-500/50 hover:border-accent-500 hover:bg-accent-500/10 text-accent-600 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('home.corporate.brochureCta')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}